import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { AddDeliveryPartnerComponent } from '../modals/add-delivery-partner/add-delivery-partner.component';
import { AddNotePopupComponent } from '../modals/add-note-popup/add-note-popup.component';
import { ChangePackagingPopupComponent } from '../modals/change-packaging-popup/change-packaging-popup.component';
import { DeliveryStatusComponent } from '../modals/delivery-status/delivery-status.component';
import { PrescriptionStatusComponent } from 'src/app/core/modals/prescription-status/prescription-status.component';
import { TransferPrescriptionStatusComponent } from 'src/app/core/modals/prescription-status-transfer/prescription-status-transfer.component';
import { DimensionWeightComponent } from '../modals/dimension-weight/dimension-weight.component';
import { InvoiceComponent } from '../modals/invoice/invoice.component';
import { MedCostPopupComponent } from '../modals/med-cost-popup/med-cost-popup.component';
import { NotificationPopupComponent } from '../modals/notification-popup/notification-popup.component';
import { PaymentPlanPopupComponent } from '../modals/payment-plan-popup/payment-plan-popup.component';
import { RenewRefillRequestComponent } from '../modals/renew-refill-request/renew-refill-request.component';
import { UserNotificationPopupComponent } from '../modals/user-notification-popup/user-notification-popup.component';
import { ReportParametersComponent } from '../modals/report-parameters/report-parameters.component';
import { SummaryComponent } from '../modals/summary/summary.component';
import { UnsaveChangesComponent } from '../modals/unsave-changes/unsave-changes.component';
import { WarningOrderPopupComponent } from '../modals/warning-order-popup/warning-order-popup.component';
import { WarningPopupComponent } from '../modals/warning-popup/warning-popup.component';
import { ConfirmationPopupComponent } from '../modals/confirmation-popup/confirmation-popup.component';
import { ConfirmationPopupCancelComponent } from '../modals/confirmation-popup-cancel/confirmation-popup-cancel.component';
import { SalePaymentPlanPopupComponent } from '../modals/sale-payment-plan-popup/sale-payment-plan-popup.component';
import { LowActivityReasonComponent } from '../modals/low-activity-reason/low-activity-reason.component';
import { HealthCarePlanStatusComponent } from 'src/app/core/modals/health-care-plan-status/health-care-plan-status.component';
import { AddSign } from 'src/app/core/modals/add-sign/add-sign.component';
import { Subject } from 'rxjs';
import { DoctorAppointmentStatusComponent } from '../modals/doctor-appointment-status/doctor-appointment-status.component';
import { PexchangeStatusComponent } from '../modals/pexchange-status/pexchange-status.component';
import { SmokingStatusChangeComponent } from '../modals/smoking-status-change/smoking-status-change.component';
import { AddRxModalComponent } from 'src/app/pages/shipping/upcoming-orders/add-rx-modal/add-rx-modal.component';
import { MergeAccountPopupComponent } from '../modals/merge-account-popup/merge-account-popup.component';
import { ConfirmSelectUserComponent } from '../modals/confirm-select-user/confirm-select-user.component';
import { DrugViewPopUpComponent } from '../modals/drug-view-pop-up/drug-view-pop-up.component';
import { ConfirmTranferTenantRingComponent } from '../modals/confirm-tranfer-tenant-ring/confirm-tranfer-tenant-ring.component';
import { DrugListPopUpComponent } from '../modals/drug-list-pop-up/drug-list-pop-up.component';
import { ViewRingPrescriptionComponent } from '../modals/view-ring-prescription/view-ring-prescription.component';
import { QuickAddUserRingComponent } from '../modals/quick-add-user-ring/quick-add-user-ring.component';
import { ConfirmReqOrderComponent } from '../modals/confirm-req-order/confirm-req-order.component';
import { UpdateRequestStatusComponent } from '../modals/update-request-status/update-request-status.component';
import { ReqAddReasonComponent } from '../modals/req-add-reason/req-add-reason.component';
import { UploadFaxDetailComponent } from '../modals/upload-fax-detail/upload-fax-detail.component';
import { ViewRxDetailComponent } from '../modals/view-rx-detail/view-rx-detail.component';
import { ClearRxPopUpComponent } from '../modals/clear-rx-pop-up/clear-rx-pop-up.component';
import { PartialConfirmPopUpComponent } from '../modals/partial-confirm-pop-up/partial-confirm-pop-up.component';
import { ReqCancelOrderComponent } from '../modals/req-cancel-order/req-cancel-order.component';
import { ConfirmForPrescriberComponent } from '../modals/confirm-for-prescriber/confirm-for-prescriber.component';
import { ConfirmAddRxComponent } from '../modals/confirm-add-rx/confirm-add-rx.component';
import { ViewDrugNamesComponent } from '../modals/view-drug-names/view-drug-names.component';
import { NeedCnfrmDialogComponent } from '../modals/need-cnfrm-dialog/need-cnfrm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  dialogRef: any;
  constructor(
    public dialog: MatDialog,
  ) {
  }
  openPackagingDialog(item: any, type: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      sale_order_rx_packagings: (item.sale_order_rx_packagings ? item.sale_order_rx_packagings : []),
      type: type,
      ID: item.ID
    };
    dialogConfig.maxHeight = "90vh";
    dialogConfig.width = "100%";
    this.dialogRef = this.dialog.open(ChangePackagingPopupComponent, dialogConfig);
  }
  openDialog(item: any, type: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { sale_order_rx_detail: item.sale_order_rx_detail, type: type };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
      dialogConfig.height = "80%";
    }
    else {
      dialogConfig.width = "70%";
      dialogConfig.height = "80%";
    }
    this.dialog.open(ReportParametersComponent, dialogConfig);
  }
  openWarningDialog(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      let dialogRef;
      dialogConfig.data = { item };
      if (window.innerWidth < 768) {
        dialogConfig.width = "90%";
      }
      else {
        dialogConfig.width = "30%";
      }

      dialogRef = this.dialog.open(WarningPopupComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback && res) {
          callback();
        }
      })

    } catch (error) {
      console.log(error);
    }
  }
  openWarningOrderDialog(data: any, type: string, callback?: Function) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { ...data, type: type };
    dialogConfig.disableClose = true;
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = "40%";
    }
    dialogRef = this.dialog.open(WarningOrderPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (callback && res) {
        callback();
      }
    })
  }
  openNotificationDialog(filterPatientList: any, patientList: any, callback: Function) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { orders: filterPatientList, patientList: patientList };
    dialogConfig.disableClose = true;
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = "30%";
    }
    dialogRef = this.dialog.open(NotificationPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (callback && res) {
        callback();
      }
    })
  }
  openPaymentPlanDialog(item: any, type: string) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { sale_order_rx_detail: item.sale_order_rx_detail, type: type, item: item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = "25%";
      dialogConfig.height = "50%";
    }
    this.dialog.open(PaymentPlanPopupComponent, dialogConfig);
  }
  openPaymentPlanDialogForSalesOrder(item: any, type: string) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { sale_order_rx_detail: item.sale_order_rx_detail, type: type, item: item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = "25%";
      dialogConfig.height = "50%";
    }
    this.dialog.open(SalePaymentPlanPopupComponent, dialogConfig);
  }
  openMedCostDialog(item: any, type: string) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { sale_order_rx_detail: item.sale_order_rx_detail, TotalMedCost: item.TotalMedCost, type: type, DeliveryCost: item.DeliveryCost };
    dialogConfig.width = "100%";
    dialogConfig.maxHeight = "90vh";
    this.dialog.open(MedCostPopupComponent, dialogConfig);
  }
  openInvoiceDialog(item: any, senderInformation: any, type: string) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { item: item, senderInformation: senderInformation, type: type };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
      dialogConfig.height = "80%";
    }
    else {
      dialogConfig.width = "60%";
      dialogConfig.height = "90%";
    }
    this.dialog.open(InvoiceComponent, dialogConfig);
  }

  openSummaryDialog(item: any, type: string) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { ...item, type: type };
    dialogConfig.maxHeight = "90vh"
    dialogConfig.panelClass = 'center-dialog-content';
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = "100%";
    }
    this.dialog.open(SummaryComponent, dialogConfig);
  }
  AddNotePopupDialog(item: any) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { ...item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
      dialogConfig.height = "50%";
    }
    else {
      dialogConfig.width = "30%";
    }
    dialogRef = this.dialog.open(AddNotePopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((resp: any) => {
      if (resp?.Notes) {
        item.Notes = resp.Notes;
      }
    });
  }
  UnsaveChangesDialog() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    if (window.innerWidth < 768) {
      dialogConfig.width = "500px";
      dialogConfig.height = "400px";
    }
    else {
      dialogConfig.width = "500px";
      dialogConfig.height = "400px";
    }
    dialogConfig.disableClose = true;
    dialogConfig.backdropClass = "backDropBlur";
    dialogRef = this.dialog.open(UnsaveChangesComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(map(res => {
      return res;
    }))
  }
  openAddDeliveryPartnerDialog(deliveryPartners: any[]) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { deliveryPartners: deliveryPartners };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = "30%";
    }
    this.dialog.open(AddDeliveryPartnerComponent, dialogConfig);
  }
  openAddLocalActiveReasonDailog(localActivityReason: any[]) {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.data = { localActivityReason: localActivityReason };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = "30%";
    }
    this.dialog.open(LowActivityReasonComponent, dialogConfig);
  }
  addDimentionWeightDialog(item: any) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { item: item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = "30%";
    }
    dialogRef = this.dialog.open(DimensionWeightComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      // if (res) {
      this.setUpdatedDiscoveryService(item)
      // }
    })
  }

  private updatedDiscoveryService = new Subject<any>();
  getUpdatedDiscoveryService = this.updatedDiscoveryService.asObservable();

  setUpdatedDiscoveryService(obj: any) {
    this.updatedDiscoveryService.next(obj)
  }
  openDeliveryStatusDialog(item: any, callback: Function) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(DeliveryStatusComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (callback && res && item.DeliveryStatus == 'Delivered') {
        callback();
      }
    })
  }
  openRenewRefillDialog(item: any, callback: Function) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(RenewRefillRequestComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (res.response.success) {
        if (callback) {
          callback();
        }
      }

    })
  }
  openNotificationPopupDialog(item: any, callback: Function) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '600px';
    }
    this.dialog.open(UserNotificationPopupComponent, dialogConfig);
  }
  openConfirmationDialog(callback: Function) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '500px';
    }
    dialogRef = this.dialog.open(ConfirmationPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (res.response) {
        if (callback) {
          callback();
        }
      }
    })
  }
  openConfirmationCancelDialog(callback: Function) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '500px';
    }
    dialogRef = this.dialog.open(ConfirmationPopupCancelComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (res.response) {
        if (callback) {
          callback();
        }
      }
    })
  }
  openPreAssessmentsStatusDialog(item: any, callback: Function): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = { item };
      if (window.innerWidth < 768) {
        dialogConfig.width = "90%";
      } else {
        dialogConfig.width = '600px';
      }
      const dialogRef = this.dialog.open(HealthCarePlanStatusComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback && res) {
          callback();
          resolve(true); // Resolving with true if condition met
        } else {
          resolve(false); // Resolving with false if condition not met
        }
      });
    });
  }

  openSmokingStatusDialog(item: any, callback: Function): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = { item };
      if (window.innerWidth < 768) {
        dialogConfig.width = "90%";
      } else {
        dialogConfig.width = '600px';
      }
      const dialogRef = this.dialog.open(SmokingStatusChangeComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback && res) {
          callback();
          resolve(true); // Resolving with true if condition met
        } else {
          resolve(false); // Resolving with false if condition not met
        }
      });
    });
  }

  openPrescriptionStatusDialog(item: any, callback: Function, client_id: any = '') {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { item, client_id };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(PrescriptionStatusComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (callback && res) {
        callback();
      }
    })
  }

  openPexchangeStatusDialog(item: any, callback: Function) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.disableClose = true;
    dialogConfig.data = { item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(PexchangeStatusComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (callback && res) {
        callback();
      }
    })
  }
  openTransferPrescriptionStatusDialog(item: any, callback: Function) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(TransferPrescriptionStatusComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (callback && res) {
        callback();
      }
    })
  }

  // appointment status modal start
  openAppointmentStatusDialog(item: any, callback: Function) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.disableClose = true;
    dialogConfig.data = { item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(DoctorAppointmentStatusComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (callback && res) {
        callback();
      }
    })
  }
  // appointment status modal end


  openSignDialog(item: any, callback: Function) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { item, callback }; // Pass the callback function to the dialog
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    } else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(AddSign, dialogConfig);

    // Subscribe to the afterClosed event to get the result
    dialogRef.afterClosed().subscribe((signature: any) => {
      // Check if the callback function is provided and call it with the signature
      if (callback && signature) {
        callback(signature);
      }
    });
  }

  openAddRXDialog(item: any, type: string, callback: Function) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { sale_order_rx_detail: item?.sale_order_rx_detail, type: type, item: item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = "25%";
      dialogConfig.height = "45%";
    }
    dialogRef = this.dialog.open(AddRxModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (callback && res) {
        callback();
      }
    });
  }

  accountMerge(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '90%' : '55%';
      const dialogRef = this.dialog.open(MergeAccountPopupComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  async openTaskModal(task?: any, additionalData?: any): Promise<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      item: task,
      ...additionalData // Spread additional data into the dialog data
    };

    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    } else {
      dialogConfig.width = "600px";
    }

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    try {
      const { AddEditTaskModalComponent } = await import('../../pages/task-management/add-edit-task-modal/add-edit-task-modal.component');
      return this.dialog.open(AddEditTaskModalComponent, dialogConfig);
    } catch (error) {
      console.error('Error loading AddEditTaskModalComponent:', error);
      return null;
    }
  }

  confirmSelectUser(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      const dialogRef = this.dialog.open(ConfirmSelectUserComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  drugViewPopup(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '90%' : '70%';
      const dialogRef = this.dialog.open(DrugViewPopUpComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  openTransferTenant(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '80%' : '35%';
      const dialogRef = this.dialog.open(ConfirmTranferTenantRingComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  openDrugListPopup(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '90%' : '80%';
      const dialogRef = this.dialog.open(DrugListPopUpComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  ViewPrescriptionDetails(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '90%' : '70%';
      const dialogRef = this.dialog.open(ViewRingPrescriptionComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  quickUserAddRing(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = '768px';
      dialogConfig.maxHeight = '90vh';
      const dialogRef = this.dialog.open(QuickAddUserRingComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }


  confirmRxAddProcessOrder(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '80%' : '35%';
      const dialogRef = this.dialog.open(ConfirmReqOrderComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  updateReqStatus(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = '500px';
      const dialogRef = this.dialog.open(UpdateRequestStatusComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  RxAddReason(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = '650px';
      dialogConfig.maxHeight = '90vh';
      const dialogRef = this.dialog.open(ReqAddReasonComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  uploadFaxDetail(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '90%' : '70%';
      const dialogRef = this.dialog.open(UploadFaxDetailComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  openRxDetailpopUp(item: any, callback: Function) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { item };
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
      dialogConfig.height = "80%";
    }
    else {
      dialogConfig.width = "70%";
      dialogConfig.height = "80%";
    }
    const dialogRef = this.dialog.open(ViewRxDetailComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (callback) {
        callback(res);
      }
    });
  } catch(error: any) {
    console.log(error);
  }

  confirmClearRxId(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '80%' : '35%';
      const dialogRef = this.dialog.open(ClearRxPopUpComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  
  confirmAddRxId(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '80%' : '800px';
      const dialogRef = this.dialog.open(ConfirmAddRxComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  confirmPartialOrder(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '90%' : '50%';
      const dialogRef = this.dialog.open(PartialConfirmPopUpComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  confirmCancelReqOrder(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '80%' : '35%';
      const dialogRef = this.dialog.open(ReqCancelOrderComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  confirmWaitingForPrescriber(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '80%' : '35%';
      const dialogRef = this.dialog.open(ConfirmForPrescriberComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  viewDrugNames(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '80%' : '35%';
      dialogConfig.autoFocus = false;
      const dialogRef = this.dialog.open(ViewDrugNamesComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  
  needConfirmPopup(item: any, callback: Function) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      dialogConfig.width = window.innerWidth < 768 ? '80%' : '35%';
      const dialogRef = this.dialog.open(NeedCnfrmDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (callback) {
          callback(res);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

}
